type IconProps = React.HTMLAttributes<SVGElement>;

export const CheckBoxIcon = (props: IconProps) => (
  <svg width="25" height="25" viewBox="0 0 25 25" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
    <rect x="0.5" y="0.0234375" width="24" height="24" rx="2" fill="#ECECEC" />
    <path d="M4.5 11.0234L11.5 17.5234L21 5.52344" stroke="white" strokeWidth="4" />
  </svg>
);
